module.exports = __webpack_public_path__ + "media/images/hortense-for-wedding/Groupe 27-7228b3ee27b51dead56474c0e0a33220.png";